import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=bbffd968&scoped=true&lang=html&"
import script from "./AboutMe.vue?vue&type=script&lang=js&"
export * from "./AboutMe.vue?vue&type=script&lang=js&"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=bbffd968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbffd968",
  null
  
)

export default component.exports